import { render, staticRenderFns } from "./MinisiteHeader.vue?vue&type=template&id=6c3c30fb&scoped=true&"
import script from "./MinisiteHeader.vue?vue&type=script&lang=js&"
export * from "./MinisiteHeader.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteHeader.vue?vue&type=style&index=0&id=6c3c30fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3c30fb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c3c30fb')) {
      api.createRecord('6c3c30fb', component.options)
    } else {
      api.reload('6c3c30fb', component.options)
    }
    module.hot.accept("./MinisiteHeader.vue?vue&type=template&id=6c3c30fb&scoped=true&", function () {
      api.rerender('6c3c30fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MinisiteHeader.vue"
export default component.exports